import { lovemoBrand, lovemoNavItems } from '@/mocks/lovemoContent';
import { lovemoScrollToSection } from '@/hooks/useLovemoScrollTo';

export default function LovemoFooter() {
  const handleNav = (sectionId: string) => {
    lovemoScrollToSection(sectionId);
  };

  return (
    <footer className="border-t border-background-200/70 bg-secondary-50 dark:bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <button
              type="button"
              onClick={() => handleNav('lovemo-home')}
              className="flex cursor-pointer items-center gap-2.5"
              aria-label="回到顶部"
            >
              <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-xl ring-1 ring-primary-200/70">
                <img
                  src={lovemoBrand.logo}
                  alt="Lovemo官方应用图标"
                  className="h-11 w-11 object-cover"
                  width={44}
                  height={44}
                />
              </span>
              <span className="flex flex-col items-start leading-none">
                <span className="font-heading text-lg font-bold text-foreground-950">Lovemo</span>
                <span className="mt-1 font-label text-xs text-primary-600">{lovemoBrand.domain}</span>
              </span>
            </button>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              Lovemo是一款懂情绪的 AI 陪伴聊天工具，随时接住你的每一句心里话。支持Lovemo官方正版免费下载、最新版官网下载，多端同步，安心陪伴。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['情绪共鸣', '24 小时在线', '语音陪伴', '多端同步'].map((tag) => (
                <span
                  key={tag}
                  className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1 font-label text-xs text-secondary-900 dark:bg-background-50"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <span>快速导航</span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {lovemoNavItems.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    onClick={() => handleNav(item.id)}
                    className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <span>获取Lovemo</span>
            </h4>
            <div className="mt-4 rounded-xl border border-background-200/70 bg-background-50 p-4">
              <p className="text-xs leading-relaxed text-foreground-600">
                通过官网即可获取官方正版安装包，支持 Android、iOS、HarmonyOS 与 Windows 多端使用。
              </p>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => handleNav('lovemo-download')}
                className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200/80 bg-background-50 px-3.5 py-2 font-label text-xs font-semibold text-primary-600 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-book-open-line" aria-hidden="true" />
                查看Lovemo下载教程
              </button>
              <button
                type="button"
                onClick={() => handleNav('lovemo-faq')}
                className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200/80 bg-background-50 px-3.5 py-2 font-label text-xs font-semibold text-secondary-700 transition-colors hover:border-secondary-300"
              >
                <i className="ri-question-line" aria-hidden="true" />
                常见问题
              </button>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-background-200/70 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} Lovemo · 保留所有权利。
          </p>
          <button
            type="button"
            onClick={() => handleNav('lovemo-home')}
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200/80 bg-background-50 px-4 py-2 font-label text-xs font-medium text-foreground-800 transition-colors hover:text-primary-600 dark:bg-background-50"
          >
            <i className="ri-arrow-up-line" aria-hidden="true" />
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}